import Link from '@material-ui/core/Link';
import React, { useEffect } from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';
import Eligibile from '../components/MessagePage/EligibilityPage';
import Error from '../components/MessagePage/Error';
import { SUPPORT_EMAIL } from '../helpers/constants';
import PropTypes from '../helpers/propTypes';
import { userMetrics } from '../userMetrics';

function PleaseTryAgain() {
  return (
    <FormattedMessage
      defaultMessage="Please try again later"
      id="Error.PleaseTryAgain"
    />
  );
}

function ErrorWrapper(props) {
  const { errorCode, onButtonClick } = props;

  useEffect(() => {
    userMetrics.track('Error screen loaded');
  }, []);

  if (errorCode === 'noToken') {
    return (
      <Error
        onButtonClick={onButtonClick}
        text={
          <FormattedMessage
            defaultMessage="Please contact support {email}"
            id="Error.NoToken"
            values={{
              email: <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>,
            }}
          />
        }
        title={
          <FormattedMessage
            defaultMessage="Token is missing or invalid"
            id="Error.NoTokenTitle"
          />
        }
      />
    );
  }
  if (errorCode === 'noSession') {
    return (
      <Error
        onButtonClick={onButtonClick}
        text={
          <FormattedMessage
            defaultMessage="The signup process has ended due to inactivity. Please restart the sign-up process."
            id="Error.SessionTimedOut"
          />
        }
        title={
          <FormattedMessage
            defaultMessage="Your session has expired"
            id="Error.SessionTimedOutTitle"
          />
        }
      />
    );
  }
  if (errorCode === 'notActive') {
    const { createdAt, status, startsIn, endsIn } = props;
    const subText = (
      <FormattedMessage
        defaultMessage="Should you have any questions or concerns, please email us at {email}."
        id="RegistrationComplete.ContactUs"
        values={{
          email: <Link href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</Link>,
        }}
      />
    );

    if (createdAt) {
      return (
        <Eligibile
          isEligible
          subText={subText}
          text={
            <FormattedMessage
              defaultMessage="This survey was already completed on {completedAt}"
              id="SurveyComplete.AlreadyCompleted"
              values={{
                completedAt: <FormattedDate value={new Date(createdAt)} />,
              }}
            />
          }
          title={
            <FormattedMessage
              defaultMessage="Already completed"
              id="SurveyComplete.AlreadyCompletedTitle"
            />
          }
        />
      );
    }

    const time = new Date().getTime();
    let title = `${status}`;
    let text = (
      <FormattedMessage
        defaultMessage="This survey is {status}"
        id="SurveyInactive.Status"
        values={{
          status,
        }}
      />
    );
    if (startsIn < 1) {
      title = (
        <FormattedMessage
          defaultMessage="Survey not started"
          id="SurveyInactive.NotStartedTitle"
        />
      );
      text = (
        <FormattedMessage
          defaultMessage="This survey will start on {date}"
          id="SurveyInactive.NotStarted"
          values={{
            date: <FormattedDate value={new Date(time - startsIn * 60000)} />,
          }}
        />
      );
    } else if (endsIn < 0) {
      title = (
        <FormattedMessage
          defaultMessage="Survey closed"
          id="SurveyInactive.EndedTitle"
        />
      );
      text = (
        <FormattedMessage
          defaultMessage="This survey ended on {date}"
          id="SurveyInactive.Ended"
          values={{
            date: <FormattedDate value={new Date(time + endsIn * 60000)} />,
          }}
        />
      );
    }
    return <Eligibile subText={subText} text={text} title={title} />;
  }

  if (errorCode === 'offline' || errorCode === 'disconnected') {
    return (
      <Error
        onButtonClick={onButtonClick}
        text={<PleaseTryAgain />}
        title={
          <FormattedMessage
            defaultMessage="No response from server"
            id="Error.NoResponse"
          />
        }
      />
    );
  }
  if (errorCode === 'locale') {
    return (
      <Error onButtonClick={onButtonClick} title="Language not supported" />
    );
  }
  return (
    <Error
      onButtonClick={onButtonClick}
      text={<PleaseTryAgain />}
      title={
        <FormattedMessage
          defaultMessage="An unknown error occurred"
          id="Error.UnknownError"
        />
      }
    />
  );
}

ErrorWrapper.propTypes = {
  createdAt: PropTypes.string,
  endsIn: PropTypes.number,
  errorCode: PropTypes.string,
  onButtonClick: PropTypes.func.isRequired,
  startsIn: PropTypes.number,
  status: PropTypes.string,
};

ErrorWrapper.defaultProps = {
  createdAt: undefined,
  endsIn: undefined,
  errorCode: undefined,
  startsIn: undefined,
  status: undefined,
};

export default ErrorWrapper;
